/**
 * The result of a list player operation.
 */
export var OperationResult;
(function (OperationResult) {
    /**
     * Denotes a successful operation.
     */
    OperationResult["SUCCESS"] = "RESULT_SUCCESS";
    /**
     * Denotes an invalid operation.
     */
    OperationResult["INVALID"] = "RESULT_INVALID";
    /**
     * Denotes that the operation failed because the operation was not allowed.
     */
    OperationResult["FORBIDDEN"] = "RESULT_FORBIDDEN";
    /**
     * Denotes that the operation failed because the index was out of bounds.
     */
    OperationResult["OUT_OF_BOUNDS"] = "RESULT_OUT_OF_BOUNDS";
    /**
     * Denotes that the operation failed because there is no list.
     */
    OperationResult["NO_LIST"] = "RESULT_NO_LIST";
    /**
     * Denotes that the operation failed because there was no track.
     */
    OperationResult["NO_TRACK"] = "RESULT_NO_TRACK";
    /**
     * Denotes that the operation failed because the list has ended.
     */
    OperationResult["LIST_END"] = "RESULT_LIST_END";
    /**
     * Denotes that the operation resulted in an invalid track.
     */
    OperationResult["INVALID_TRACK"] = "RESULT_INVALID_TRACK";
    /**
     * Denotes that the list operation was cancelled.
     */
    OperationResult["CANCELLED"] = "CANCELLED";
    /**
     * Denotes that the list operation failed because there is no track player.
     */
    OperationResult["NO_TRACK_PLAYER"] = "NO_TRACK_PLAYER";
})(OperationResult || (OperationResult = {}));
//# sourceMappingURL=operation_result.js.map